import { Autocomplete, SxProps, TextField, Theme } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import useCourseSelect_GetOptions from "~/modules/course/api/useCourseSelect_GetOptions";

type Props = {
    value: string[];
    onChange: (value: string[]) => void;
    sx?: SxProps<Theme>;
};

export default function UserCourseSelect({ value, onChange, sx }: Props) {
    const { t } = useTranslation("user");
    const { data, loading } = useCourseSelect_GetOptions();

    const selectedIds = useMemo(() => new Set(value.filter(Boolean)), [value]);
    const selectedValue = useMemo(() => data.filter(o => selectedIds.has(o.value)), [data, selectedIds]);
    const availableOptions = useMemo(() => data.filter(o => !selectedIds.has(o.value)), [data, selectedIds]);

    return (
        <Autocomplete
            multiple
            size="small"
            sx={sx}
            options={availableOptions}
            loading={loading}
            value={selectedValue}
            onChange={(_, newValue) => onChange(newValue.map(o => o.value))}
            getOptionLabel={option => option.label}
            getOptionKey={option => option.value}
            renderInput={params => (
                <TextField {...params} fullWidth label={t("userListScreen.filterCourse")} variant="outlined" />
            )}
        />
    );
}
